var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.img)?_c('v-img',{staticClass:"mb-4",attrs:{"src":_vm.getImage(_vm.img),"contain":""}}):_vm._e(),_c('v-btn',{staticClass:"button",attrs:{"outlined":"","block":"","x-large":"","depressed":"","href":_vm.link,"color":"#d2d2d7"}},[_vm._v(" "+_vm._s(_vm.text || _vm.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }